import { createApp } from 'vue'
import '@/css/global'
import '@/permission'

import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import { L } from '@/store/L.js'
import 'element-plus/dist/index.css'
import 'flag-icons/css/flag-icons.css'
import * as Icons from '@element-plus/icons-vue'
import moment from 'moment-timezone'
// import commonDialog from '@/components/common-dialog'
//引入语言包
import i18n from '@/languages'
import handels from './utils/handels'
/* 在线聊天工具 start */
var Tawk_API = Tawk_API || {},
    Tawk_LoadStart = new Date();
// (function() {
//     var s1 = document.createElement("script"),
//         s0 = document.getElementsByTagName("script")[0];
//     s1.async = true;
//     s1.src = 'https://embed.tawk.to/67bfdfb54ade3e1907e2d7d8/1il2o3ne4';
//     s1.charset = 'UTF-8';
//     s1.setAttribute('crossorigin', '*');
//     s0.parentNode.insertBefore(s1, s0);

// })();
/* 在线聊天工具 end */

const app = createApp(App)
Object.keys(Icons).forEach(key => {
    app.component(key, Icons[key])
})
const Log = (log, ...args) => {
    console.log("【", Date.now(), "】DEBUG===", log, ...args)
}
app.config.globalProperties.$L = L;
app.config.globalProperties.$Log = Log;
window.$L = L;
window.$Log = Log;
window.$routerModelStr = "/";
app.config.globalProperties.$routerModelStr = window.$routerModelStr;
app.config.globalProperties.$moment = moment
window.moment = moment
app.config.globalProperties.$routes = function(path) {
    // 自定义路径函数，用于处理路由路径
    return window.$routerModelStr.replace(/(\/)/g, "") + path;
}
const CurrentLangeuage = handels.CurrentLangeuage(true);
window.$CurrentLangeuage = CurrentLangeuage;
app.config.globalProperties.$CurrentLangeuage = CurrentLangeuage;
app
    .use(i18n) // 注册国际化
    .use(router) // 注册路由系统
    .use(store)


// .component('common-dialog', commonDialog)
.mount('#app')